import React from 'react';
import { Box, Typography, Card, CardActionArea, CardContent, Container, Grid } from '@mui/material';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import MovieFilterIcon from '@mui/icons-material/MovieFilter';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import TimelineIcon from '@mui/icons-material/Timeline';
import TranslateIcon from '@mui/icons-material/Translate';
import QuizIcon from '@mui/icons-material/Quiz';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';

const PortalHome: React.FC = () => {
  const apps = [
    {
      title: 'Deutsche Wahlen 2025',
      description: 'Gib deine Prognose für die Bundestagswahl ab!',
      icon: <HowToVoteIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
      link: '/wahlen'
    },
    {
      title: 'Zukunft 2026',
      description: 'Prognostiziere Ereignisse und gewinne Punkte.',
      icon: <TimelineIcon sx={{ fontSize: 60, color: 'info.main' }} />,
      link: '/zukunft'
    },
    {
      title: 'Henoch',
      description: 'Erkenne dich selbst.',
      icon: <SelfImprovementIcon sx={{ fontSize: 60, color: '#9c27b0' }} />, // Lila
      link: '/henoch'
    },
    {
      title: 'Bilderrate',
      description: 'Errate den Film anhand von Zeichnungen.',
      icon: <MovieFilterIcon sx={{ fontSize: 60, color: 'secondary.main' }} />,
      link: '/bildrate'
    },
    {
      title: 'Rattenfänger-Quiz',
      description: 'Das Partyspiel zum Gruppenchat: Fernseher an, Handys raus – wie bei Jackbox.',
      icon: <QuizIcon sx={{ fontSize: 60, color: '#ff4d8d' }} />,
      link: '/quiz'
    },
    {
      title: 'Rangiert',
      description: 'Ordne deine Kategorie und rate, wie die anderen sortieren würden – Partyspiel mit Handys und Fernseher.',
      icon: <LeaderboardIcon sx={{ fontSize: 60, color: '#ffc53d' }} />,
      link: '/rangiert'
    },
    {
      title: 'Der, Die, Das',
      description: 'Lerne die deutschen Artikel!',
      icon: <TranslateIcon sx={{ fontSize: 60, color: '#4caf50' }} />,
      link: '/artikel'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold" color="primary">
          Willkommen im Mahbis Wettlokal
        </Typography>
        <Typography variant="h6" component="p" color="text.secondary">
          Dein Portal für Prognosen, Spiele und mehr.<br />
          Wähle eine App aus, um zu starten.
        </Typography>
      </Box>

      <Grid container spacing={4} justifyContent="center">
        {apps.map((app) => (
          <Grid item xs={12} sm={6} md={4} key={app.title}>
            <Card 
              sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column', 
                transition: 'all 0.3s ease-in-out',
                '&:hover': { 
                  transform: 'translateY(-8px)',
                  boxShadow: '0 12px 24px rgba(0,0,0,0.1)'
                } 
              }}
            >
              <CardActionArea href={app.link} sx={{ height: '100%', p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
                <Box sx={{ 
                  mb: 2,
                  p: 2,
                  borderRadius: '50%',
                  backgroundColor: 'action.hover',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {app.icon}
                </Box>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Typography gutterBottom variant="h5" component="h2" fontWeight="bold">
                    {app.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {app.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default PortalHome;
